import {
	DBxEvent
} from "cartovista";
import { createFeatures } from "cartovistaExtend/utils/CvUtils";
import { queryBaseLayer } from "cartovistaExtend/utils/ServerRequests";


let zoomLayeringServer = class ZoomLayeringServer {
  constructor(layerConfig) {
    this._map = window.cartovista.getMap(C.MAP.ID);
    this._map.addEventListener(this._map.EVENTS.EXTENT_CHANGED, _.debounce(this._onMapExtentOrLayerVisibleChanged, 250), this);
    this._layerConfig = layerConfig;
    this._baseLayerId = layerConfig.ZOOM_LAYERING.BASE_LAYER_ID;
    this._genLayerId = layerConfig.LAYER_ID;
    this._switchScale = layerConfig.ZOOM_LAYERING.SWITCH_SCALE;
    this._pendingRequestFeatures = [];
    //promise that waits for layer created in map
    new Promise(function(resolve, reject) {
        if (this._map.getLayer(layerConfig.LAYER_ID) == null) {
            window.cartovista.addOneTimeEventListener(layerConfig.LAYER_ID + "_layerCreated", resolve);
        } else {
            resolve();
        }
    }.bind(this)).then(function() {
        this._layer = this._map.getLayer(this._layerConfig.LAYER_ID);
        this._layer.addEventListener(this._layer.EVENTS.VISIBLE_CHANGED, this._onMapExtentOrLayerVisibleChanged, this);
    }.bind(this));
  }


    _onMapExtentOrLayerVisibleChanged(e) {
        if (this._layer.visible) {
            if (this._map.mapScale < this._switchScale) {
                this._replaceGenByBaseGeometries();
            } else {
                this._replaceBaseByGenGeometries();
            }
        }
    };

    _replaceBaseByGenGeometries() {
        //get base features list in the current map extent
        var features = this._getBaseFeaturesByExtent(this._map.extent);
        //handle only features with zoomLayeringState == undefined or "base", else they are already replaced
        var featuresToSwitch = _.filter(features, function(feature) {
            return typeof feature.zoomLayeringState == "undefined" || feature.zoomLayeringState == "base";
        });
        //switch features to gen geometry
        this._switchBaseToGenGeometry(featuresToSwitch);
    };

    _replaceGenByBaseGeometries() {
        //get gen features list in the current map extent
        var features = this._getGenFeaturesByExtent(this._map.extent);
        var featuresToSwitch = [];
        var featuresToRequest = [];
        _.forEach(features, function(feature) {
            //set zoomLayeringState to base here to prevent redundant requests in case of
            //multiples zooms in and zooms out before the request responses arrived
            feature.zoomLayeringState = "base";
            if (feature._geometries.length > 1) {
                //feature ready to switch because base geometry was already added
                featuresToSwitch.push(feature);
            } else {
                //feature's base geometry is not added already
                featuresToRequest.push(feature);
            }
        });
        //switch features that base geometry is already added
        this._switchGenToBaseGeometry(featuresToSwitch);
        //request baseFeatures then switch geometry
        _.forEach(featuresToRequest, function(feature) {
            this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION.QUERIES[0].VALUE = feature.id;
            queryBaseLayer(this._layerConfig, this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION, this._layerConfig.ZOOM_LAYERING.QUERY_FIELDS)
                .then(function(response) {
                    this._addBaseGeometryToFeatures([feature], [response.features[0]]);
                    this._switchGenToBaseGeometry([feature]);
                }.bind(this));
        }.bind(this));
    };

    _addBaseGeometryToFeatures(features, featuresData) {
        var baseFeatures = createFeatures(this._layerConfig, featuresData);
        _.forEach(features, function(feature, idx) {
            feature.addGeometries(baseFeatures[idx].currentGeometry);
        });
        return features;
    };

    _getGenFeaturesByExtent(extent) {
        var features;
        this._layer.getFeaturesByExtent(extent, function(result) {
            //handle only features with zoomLayeringState == undefined or "gen", else they are already replaced
            features = _.filter(result.features, function(feature) {
                return typeof feature.zoomLayeringState == "undefined" || feature.zoomLayeringState == "gen" && feature.visible && !feature.filteredOut;
            });
        });
        return features;
    };

    _getBaseFeaturesByExtent(extent) {
        var features;
        this._layer.getFeaturesByExtent(extent, function(result) {
            features = _.filter(result.features, function(feature) {
                //handle only features with zoomLayeringState == undefined or "base", else they are already replaced
                return typeof feature.zoomLayeringState == "undefined" || feature.zoomLayeringState == "base" && feature.visible && !feature.filteredOut;
            });
        });
        return features;
    };

    _switchGenToBaseGeometry(features) {
        if (Array.isArray(features) && features.length > 0) {
            _.forEach(features, function(feature) {
                feature.zoomLayeringState = "base";
                feature._setCurrentGeometry(feature._geometries[1]);
            });
            this._layer.dispatchEvent(new DBxEvent(this._layer.EVENTS.CONTENT_CHANGED));
        }
    };

    _switchBaseToGenGeometry(features) {
        if (Array.isArray(features) && features.length > 0) {
            _.forEach(features, function(feature) {
                feature.zoomLayeringState = "gen";
                feature._setCurrentGeometry(feature._geometries[0]);
            });
            this._layer.dispatchEvent(new DBxEvent(this._layer.EVENTS.CONTENT_CHANGED));
        }
    };
  }

    export {
      zoomLayeringServer as
      default
    };
